import { Box, Typography } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { DEFAULT_PUBLICATION_TOC_HEIGHT_OPTION } from '@opengov/stories-shared/constants';
import { IPublicationTocSettings } from '@opengov/stories-shared/types';
import { range } from 'lodash';
import React from 'react';

import { ColumnPlaceholderText } from './ColumnPlaceholderText';
import { styles } from './TableOfContentsPreview.styles';

type ITableOfContentsPreviewProps = {
  tocSettings: IPublicationTocSettings;
};

const PREVIEW_DOWNSIZE = 0.25;

export function TableOfContentsPreview({ tocSettings }: ITableOfContentsPreviewProps) {
  const dynamicStyles = {
    height: tocSettings.headerHeightSize
      ? `calc(${tocSettings.headerHeightSize} * ${PREVIEW_DOWNSIZE} )`
      : `calc(${DEFAULT_PUBLICATION_TOC_HEIGHT_OPTION} * ${PREVIEW_DOWNSIZE} )`
  };

  return (
    <Box>
      {tocSettings.headerImageUrl ? (
        <Box sx={styles.headerImageContainer} style={dynamicStyles} data-test="toc-preview-header-image">
          <img alt="header" src={tocSettings.headerImageUrl} />
        </Box>
      ) : (
        <Box
          sx={[styles.headerImageContainer, styles.noImagePlaceholder]}
          style={dynamicStyles}
          data-test="toc-preview-header-image"
        >
          <ImageIcon aria-hidden={true} />
        </Box>
      )}
      <Box sx={styles.tocPreviewBody}>
        <Typography variant="subtitle1" data-test="toc-preview-page-title">
          {tocSettings.pageTitle}
        </Typography>

        {tocSettings.description && (
          <Typography
            component="p"
            variant="body2"
            color="text.secondary"
            sx={styles.descriptionText}
            data-test="toc-preview-description"
          >
            {tocSettings.description}
          </Typography>
        )}

        <Box
          sx={styles.placeholderTextContainer}
          data-test={`toc-preview-columns-layout-${tocSettings.columnLayoutNumber}`}
        >
          {range(1, tocSettings.columnLayoutNumber + 1).map((columnNumber) => {
            return (
              <Box sx={styles.column} key={columnNumber}>
                <ColumnPlaceholderText />
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}
